<template>
  <div class="candidates-list" v-loading="loading">
    <a
      class="candidate-item"
      v-for="(item, index) in allResponds"
      v-infinite-scroll="loadMore"
      :infinite-scroll-last="index == allResponds.length - 1"
      :key="`${item.bean.id.value}_${index}`"
      :href="`/index.php?module=HRPAC_CANDIDATE_RESPONDS&action=DetailView&record=${item.bean.id.value}`"
    >
      <Avatar
        class="candidate-item__avatar"
        :size="48"
        :url="`/index.php?entryPoint=download&id=${item.bean.id.value}_photo&type=HRPAC_CANDIDATE_RESPONDS`"
      />
      <div class="candidate-item__wrapper">
        <div class="candidate-item__name">
          {{ formatHtml(item.bean.name.value) }}
        </div>
        <div class="candidate-item__info">
          {{
            `${modifedJobTitle(
              formatHtml(item.bean.vacancy_job_type.value)
            )} ${item.bean.date_entered.value.split(' ').shift()}`
          }}
        </div>
      </div>
    </a>
    <Loader v-if="loading" />
  </div>
</template>
<script>
import { store } from '@/store';
import { mixin } from '@/utils/mixins';
import Avatar from 'Elements/Avatar/Avatar';
import Loader from 'Elements/Loader/Loader';

export default {
  mixins: [mixin],
  components: {
    Avatar,
    Loader
  },
  computed: {
    allResponds() {
      return store.state.respond.allResponds;
    },
    fields() {
      return store.state.vacancy.fields || {};
    },
    loading() {
      return store.state.respond.loading;
    }
  },
  data() {
    return {
      page: 0
    };
  },
  methods: {
    modifedJobTitle(title) {
      switch (title) {
        case 'hh':
          return 'Headhunter';
        case 'avito':
          return 'Авито';
        case 'superjob':
          return 'SuperJob';
        case 'vkrabota':
          return 'VKRabota';
        case 'career':
          return 'Карьерная страница';
        case 'rabotaru':
          return 'Работа.Ру';

        default:
          return '';
      }
    },
    async loadMore() {
      this.page++;
      store.dispatch('respond/getRespondsPage', {
        id: this.fields.id.value,
        page: this.page
      });
    }
  },
  destroyed() {
    store.commit('respond/setAllResponds', []);
  }
};
</script>
<style lang="scss" scoped>
.candidates-list {
  padding: 20px;
}

.candidate-item {
  display: flex;
  flex-direction: row;
  padding: 12px;
  cursor: pointer;

  &__avatar {
    align-self: center;
    -ms-grid-row-align: center;
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    margin-left: 12px;
    font-size: 14px;
    cursor: pointer;
  }

  &__name {
    line-height: 20px;
    font-weight: bold;
    color: $black-190;
  }

  &__info {
    line-height: 24px;
    color: $black-100;
  }

  &:hover {
    background: $blue-10;
    border-radius: 8px;
  }
}
</style>
